import { Greeting } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchGreeting } from './GreetingSlice';
import { GreetingDataSelector } from './GreetingDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function useGreeting(): AbstractDataState<Greeting, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchGreeting, GreetingDataSelector);
}
